import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import queryString from 'query-string';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import Header from 'components/Header/Header';
import Footer from 'components/Footer';
import Template from 'components/Template/Template';
import LoginForm from './LoginForm';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { isLoggedIn, getCurrentUserRole } from 'ducks/authentication';
import ResetPasswordRequestForm from 'components/UI/ResetPassword/ResetPasswordRequestForm';
import Banner from 'components/Banner/Banner';
import i18n from 'helpers/i18n';
import Container from '@material-ui/core/Container';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
const styles = (theme) => {
  return {
    root: {
      minHeight: '100%',
      height: '100%',
      // display: "flex",
      // flexDirection: "column",
      // "& > *": {
      //   flex: 1,
      // },
    },
    header: {
      height: 150,
      [theme.breakpoints.down('sm')]: {
        height: 200,
      },
    },
    content: {
      height: 'calc(100% - 150px - 120px)',
      minHeight: '580px',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    footer: {
      height: 120,
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    paperWrapper: {
      width: '100%',
    },
    paper: {
      padding: theme.spacing(4),
    },
  };
};
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
    };
    this._onLoginPasswordReset = this._onLoginPasswordReset.bind(this);
    this._onRegistrationCancel = this._onRegistrationCancel.bind(this);
  }
  _onLoginPasswordReset() {
    this.setState({
      step: 3,
    });
  }
  _onRegistrationCancel() {
    this.setState({
      step: 1,
    });
  }
  render() {
    const { onPanelToggle, classes, userRole, isLoggedIn } = this.props;
    const { step } = this.state;
    if (isLoggedIn) {
      const uri = queryString.parse(window.location.search);
      const url = uri._pn !== undefined ? decodeURIComponent(uri._pn) : '/';
      return (
        <Redirect
          to={{
            pathname: url,
            state: { from: this.props.location },
          }}
        />
      );
    }
    return (
      <Template current={'login'} headerImage="background">
        <Fade in timeout={1000} style={{ height: '100%' }}>
          <Box width="100%" align="middle">
            <Paper square elevation={0} className={classes.paper}>
              <If condition={step === 1}>
                <If condition={i18n.has('subscriptionFormVisitorTitle')}>
                  <Typography variant="h2" gutterBottom>
                    {' '}
                    {i18n.get('subscriptionFormVisitorTitle')}
                  </Typography>
                </If>
                <Grid container spacing={2} alignContent="flex-start">
                <Grid item xs={12} sm={12}>
                  <Typography variant="h3" className={classes.title}>
                    {i18n.get('loginFormTitle')}
                  </Typography>
                <LoginForm
                  onFormComplete={this._onLoginFormComplete}
                  onPasswordResetRequest={this._onLoginPasswordReset}
                  footerAlign={'left'}
                />
              </Grid>
{/*              <Grid item xs={12} sm={6}>
                <Typography variant="h3" className={classes.title}>
                  {i18n.get('registrationFormTitle')}
                </Typography>

                <Button variant="contained" color="primary">boo</Button>
              </Grid>*/}
              </Grid>
              </If>
              <If condition={step === 3}>
                <ResetPasswordRequestForm onFormCancel={this._onRegistrationCancel} noTitle />
              </If>
            </Paper>
          </Box>
        </Fade>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    userRole: getCurrentUserRole(state),
    isLoggedIn: isLoggedIn(state),
  };
  return props;
}
export default withStyles(styles)(withRouter(connect(mapStateToProps)(Login)));



// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx